import { Component, OnInit } from '@angular/core';
import { Form, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../services/api.service';
import { UserService } from '../../../../services/user.service';
import { NotificationService } from '../../../../services/notification.service';
import { LocationModalComponent } from '../../../shared/location-modal/location-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-new-address',
  templateUrl: './new-address.component.html',
  styleUrl: './new-address.component.scss',
})
export class NewAddressComponent implements OnInit {
  editMode: any;
  addresses: any;

  center = { lat: 20, lng: 77 };
  zoom = 5;
  marker = { lat: 20, lng: 77 };
  markerOptions = { draggable: true };

  constructor(
    private http: ApiService,
    private user: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private notify: NotificationService,
    private modal: NgbModal
  ) {}
  locationSub: any;
  isLoading = false;
  registerForm = new FormGroup({
    title: new FormControl(''),
    blockNo: new FormControl(''),
    landmark: new FormControl(''),
    address: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    zipcode: new FormControl('', [
      Validators.pattern('[0-9]+'),
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
    ]),
    city: new FormControl('', Validators.required),
    area: new FormControl(''),
    latVal: new FormControl('', Validators.required),
    lngVal: new FormControl('', Validators.required),
    zone: new FormControl(''),
    primaryAddress: new FormControl(false, Validators.required),
  });

  ngOnInit() {
    if (this.route.snapshot.params['id']) {
      const id = this.route.snapshot.params['id'];
      this.editMode = id;
      this.http.get('retailers/myaddress').subscribe((res) => {
        this.addresses = res.data;
        this.registerForm.patchValue({
          ...res.data.find(({ addressId }) => addressId == id),
        });
      });
    }
  }

  f = (control) => this.registerForm.get(control) as FormControl;

  onSubmit() {
    const { status, value } = this.registerForm;
    console.log(this.registerForm);
    if (status == 'INVALID') {
      this.registerForm.markAllAsTouched();
      return;
    }
    console.log(value);
    const data =
      this.editMode != null
        ? {
            url: 'retailers/editAddress',
            message: 'Address updated successfully',
            payload: {
              ...value,
              addressId: this.editMode,
            },
          }
        : {
            url: 'retailers/addaddress',
            payload: value,
            message: 'Address added successfully',
          };
    this.isLoading = true;
    this.http.post(data.url, data.payload).subscribe((res) => {
      console.log(res);
      this.isLoading = false;

      if (res.code == 1) {
        this.notify.showSuccess(data.message, '');
        this.router.navigate(['/dashboard/profile/saved-addresses']);
      } else {
        this.notify.showError(res.message, '');
      }
    });
  }

  getLocation() {
    // this.http.getCoordinates().then((pos) => {
    //   const {
    //     coords: { latitude, longitude },
    //   } = pos;
    //   this.http.getLocation(pos).subscribe(({ results }: any) => {
    //     const [addr] = results;
    //     const arr = results[0].address_components;
    //     this.registerForm.patchValue({
    //       address: addr.formatted_address,
    //       area: this.user.decodeAddress(arr, 'administrative_area_level_2'),
    //       city: this.user.decodeAddress(arr, 'locality'),
    //       zone: this.user.decodeAddress(arr, 'locality'),
    //       state: this.user.decodeAddress(arr, 'administrative_area_level_1'),
    //       zipcode: this.user.decodeAddress(arr, 'postal_code'),
    //       latVal: latitude + '',
    //       lngVal: longitude + '',
    //     });
    //   });
    // });
  }

  async selectLocation() {
   const ref = this.modal.open(LocationModalComponent, {
     size: 'lg',
     centered: true,
   });
   try {

    const res = await ref.result;  
    // { coords: { lat, lng }, place: PlaceResult }

    const { coords, place } = res;
    const arr = place.address_components; // ✔️ not undefined

    this.registerForm.patchValue({
      latVal: coords.lat.toFixed(6),
      lngVal: coords.lng.toFixed(6),
      address: place.formatted_address,
      area: this.user.decodeAddress(arr, 'administrative_area_level_2'),
      city: this.user.decodeAddress(arr, 'locality'),
      zone: this.user.decodeAddress(arr, 'administrative_area_level_2'),
      zipcode: this.user.decodeAddress(arr, 'postal_code'),
      state: this.user.decodeAddress(arr, 'administrative_area_level_1'),
    });
   } catch {
     // Modal dismissed
   }
  }

  

  // selectLocation() {
  //   this.locationSub = this.user.map.subscribe((res: any) => {
  //     console.log(res);

  //     const { address, latitude, longitude } = res;
  //     const arr = address.address_components;
  //     this.registerForm.patchValue({
  //       address: address.formatted_address,
  //       area: this.user.decodeAddress(arr, 'administrative_area_level_2'),
  //       city: this.user.decodeAddress(arr, 'locality'),
  //       zone: this.user.decodeAddress(arr, 'locality'),
  //       zipcode: this.user.decodeAddress(arr, 'postal_code'),
  //       state: this.user.decodeAddress(arr, 'administrative_area_level_1'),
  //       latVal: latitude + '',
  //       lngVal: longitude + '',
  //     });
  //     if (address) {
  //       this.locationSub.unsubscribe();
  //       this.user.map.next(null);
  //     }
  //   });
  // }

  goBack() {
    this.router.navigate(['/dashboard/profile/saved-addresses']);
  }
}
